// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4ddd90e2","498":"20efc46e","703":"3de3b10f"}[chunkId] + ".chunk.js";
};